export const isFullStatic = false
export const staticPath = "/home/circleci/repo/container/web/.nuxt/static-json"
export const publicPath = "https://assets.coconala.com/_nuxt/prod/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"